import AlipaySdkManager from './AlipaySdkManager.native';
export * from './Types';

export default AlipaySdkManager;
